import { useCallback, useState } from 'react'

interface StickerType {
  id: string;
  url: string;
  x: number;
  y: number;
  width: number;
  height: number;
}

const useStickers = () => {
  const [stickers, setStickers] = useState<StickerType[]>([]);
  const [selectedStickerId, setSelectedStickerId] = useState<string | null>(null);

  const addStickers = useCallback((src: string) => {
    const newSticker: StickerType = {
      id: `sticker-${Date.now()}`,
      url: src,
      x: 50,
      y: 50,
      width: 100,
      height: 100,
    };
    setStickers((prev) => [...prev, newSticker]);
    setSelectedStickerId(newSticker.id);
  }, [])

  const updateSticker = useCallback((id: string, updates: Partial<any>) => {
    setStickers((prev) =>
      prev.map((sticker) =>
        sticker.id === id ? { ...sticker, ...updates } : sticker
      )
    );
  }, [])

  const selectSticker = useCallback((id: string) => {
    setSelectedStickerId(id);
  }, [])

  const deleteSticker = useCallback((id: string) => {
    setStickers((prev) => prev.filter((sticker) => sticker.id !== id));
    setSelectedStickerId((prevSelected) => (prevSelected === id ? null : prevSelected));
  }, [])

  return { addStickers, stickers, selectedStickerId, updateSticker, deleteSticker, selectSticker };
}

export default useStickers;